import {
  ContactDm2Response,
  ContactDm2Request,
} from 'sigma-mappings';
import translate from '@/services/translate';
import Http from '@/services/http';

const apiFieldDefinitions = {
  CorrenteMinima: {
    label: 'sensors.configuration-dm2.min-current',
  },
  CorrenteMaxima: {
    label: 'sensors.configuration-dm2.max-current',
  },
  RangeMinimo: {
    label: 'sensors.configuration-dm2.min-range',
  },
  RangeMaximo: {
    label: 'sensors.configuration-dm2.max-range',
  },
  Descricao: {
    label: 'sensors.configuration-dm2.description',
  },
  UnidadeMedida: {
    label: 'sensors.configuration-dm2.measuring-unit',
  },
  ValorReferenciaAtuacaoAlarme: {
    label: 'sensors.configuration-dm2.modal.value',
  },
  AtivaAlarme: {
    label: 'sensors.configuration-dm2.modal.activate-alarm',
  },
  CondicaoAtuacaoAlarme: {
    label: 'sensors.configuration-dm2.modal.actuation-alarm-condition',
  },
};

const error = {
  errorHandling: {
    responseMessageParams: {
      $MA001: (data) => {
        const returnedField = apiFieldDefinitions[data.field];
        if (!returnedField) return null;

        return {
          NomeDoCampo: translate(returnedField.label),
        };
      },
      $MA029: (data) => {
        const returnedField = apiFieldDefinitions[data.field];
        if (!returnedField) return null;

        return {
          FaixaInicial: data.parameters[0],
          FaixaFinal: data.parameters[1],
          NomeDoCampo: translate(returnedField.label),
        };
      },
      $MA051: (data) => {
        const returnedField = apiFieldDefinitions[data.field];
        return {
          maxLength: data.parameters[0],
          fieldName: translate(returnedField.label),
        };
     },
     $MA109: (data) => {
      const firstField = apiFieldDefinitions[data.parameters[0]];
      const secondField = apiFieldDefinitions[data.parameters[1]];

      return {
        0: translate(firstField.label),
        1: translate(secondField.label),
      };
     },
    },
  },
};

const urls = {
  getContactsBySensor: sensorId => `/supervisao/dm2/${sensorId}/configuracoes`,
  updateOrDeleteContact: id => `/supervisao/dm2/configuracoes/${id}`,
  getContactById: (sensorId, id) => `/supervisao/dm2/${sensorId}/contatos/${id}`,
};

export default {
  getContactsBySensor(sensorId) {
    const http = new Http();
    return http.get(urls.getContactsBySensor(sensorId))
      .then(({ data }) => data.map(item => new ContactDm2Response(item)));
  },
  getContactById(sensorId, id) {
    const http = new Http();
    return http.get(urls.getContactById(sensorId, id))
      .then(({ data }) => new ContactDm2Response(data));
  },
  updateContact(contact) {
    const http = new Http(error);
    return http.put(
      urls.updateOrDeleteContact(contact.id),
      new ContactDm2Request(contact),
    );
  },
  deleteContact(contactId) {
    const http = new Http();
    return http.delete(urls.updateOrDeleteContact(contactId));
  },
};
